import React from "react";

import "./Wordglobe.css";

import TagCloud from "@frank-mayer/react-tag-cloud";

const Wordglobe = () => {
  return (
    <>
      <div className="text-sphere">
        <span className="tagcloud">
          <TagCloud
            options={(w: Window & typeof globalThis): TagCloudOptions => ({
              radius: Math.min(500, w.innerWidth, w.innerHeight) / 2,
              maxSpeed: "fast",
            })}
          >
            {[
              "Fashion show" ,
              "Singing",
              "Dancing",
              "Facepainting",
              "Sandart/Rangoli",
              "Bughunt",
              "DevQuest",
              "MouseRace",
              "BGMI squad Battle",
              "Jam ",
              "short film"
            ]}
          </TagCloud>
        </span>
      </div>
    </>
  );
};

export default Wordglobe;